import { decode } from '@/base64';
import { MultipleChoiceView } from './MultipleChoiceView';
import { OpenQuestionView } from './OpenQuestionView';
import { NamePartsView } from './NamePartsView';
import { MatrixView } from './MatrixView';
import { OrderView } from './OrderView';
import { ConnectView } from './ConnectView';
import { MathView } from './MathView';
import { InstructionView } from './InstructionView';
import { UploadView } from './UploadView';
import { InvulVraagView } from './InvulVraagView';
import { BoxQuestionView } from './BoxQuestionView';
import { BoxQuestionViewOld } from './BoxQuestionViewOld';
import { ImageShowPartsView } from './ImageShowPartsView';
import { TabbedContentBoxView } from './TabbedContentBoxView';
import { BoxErrorView } from './BoxErrorView';
import { SortGroupsView } from './SortGroupsView';
import { ShowOnPictureView } from './ShowOnPictureView';
import { countsTowardQuestionNumber } from './questionNumbering';
import { isString, orderWidgets, deep_copy } from '@/util';
import i18n from 'i18next';

import { Subject, BehaviorSubject, skip } from 'rxjs';
import React from 'react';

import ReactDOM from 'react-dom';

export function getView(state) {
  let View;
  switch (state.type) {
    case 'InvulVraag':
      View = InvulVraagView;
      break;
    case 'MeerKeuze':
      View = MultipleChoiceView;
      break;
    case 'OpenVraag':
      View = OpenQuestionView;
      break;
    case 'MatrixVraag2':
      View = MatrixView;
      break;
    case 'OrderVraag':
      View = OrderView;
      break;
    case 'Link':
      View = ConnectView;
      break;
    case 'NameImage':
    case 'NameImage2':
      View = NamePartsView;
      break;
    case 'Math':
      View = MathView;
      break;
    case 'FileUpload':
      View = UploadView;
      break;
    case 'KofferVraag2':
      View = BoxQuestionView;
      break;
    case 'KofferVraag':
      View = BoxQuestionViewOld;
      break;
    case 'ImageShowParts':
      View = ImageShowPartsView;
      break;
    case 'TabbedContentBoxes':
      View = TabbedContentBoxView;
      break;
    case 'BoxError':
      View = BoxErrorView;
      break;
    case 'Instruction':
      View = InstructionView;
      break;
    case 'SortGroups':
      View = SortGroupsView;
      break;
    case 'ShowOnPicture':
      View = ShowOnPictureView;
      break;
  }
  return View;
}

export function renderWidget(
  state,
  target,
  i = 0,
  correction = null,
  {
    isCorrected = false,
    showAnswers = false,
    correctionType = 'automatic',
    courseStatus = undefined,
    lesson = null,
  },
  isExtraInfo,
  userId
) {
  let View = getView(state);
  const uid = String(state?.uid || '');
  if (!uid) {
    console.error('Unable to render widget without a uid', state);
    return;
  }
  const escapedUid = CSS.escape(uid);
  const placeholder =
    target?.id === uid ? target : target?.querySelector?.(`#${escapedUid}`);
  if (!placeholder) {
    console.error('Unable to render', placeholder, 'placeholder not found');
    return;
  }
  placeholder.innerHTML = '';

  if (!View) {
    console.error('Error: rendering', state);
    return null;
  }

  let widget = {
    onModified: new Subject(),
    onSave: new Subject(),
    state: state,
  };

  let widgetCorrection = correction?.[state.uid];
  if (!widgetCorrection && correction) {
    const availableCorrections = Object.values(correction);
    widgetCorrection = availableCorrections.find((corr) => {
      return (
        corr?.state?.vraag === state?.vraag && corr?.state?.type === state?.type
      );
    });
  }

  let antwoord = null;
  if (state?.antwoord && isString(state?.antwoord)) {
    antwoord = state?.antwoord?.replace?.(/ contenteditable="true"/g, '');
  }

  setTimeout(() => {
    orderWidgets(placeholder.closest('.fr-view') || placeholder.ownerDocument);
  }, 0);

  const Wrapper = state?.type === 'Math' && state?.inline ? 'span' : 'div';
  widget.portal = ReactDOM.createPortal(
    <>
      <Wrapper
        className={`${
          !state?.noSubmit &&
          state?.type != 'Math' &&
          state?.type != 'ImageShowParts' &&
          state?.type != 'TabbedContentBoxes'
            ? 'widget_practical '
            : ''
        } print-keep print:break-inside-avoid print:overflow-visible`}
      >
        <View
          correctionType={correctionType}
          courseStatus={courseStatus}
          setAnswerFn={(fn) => (widget.answerFn = fn)}
          setCorrectionFn={(fn) => (widget.correctionFn = fn)}
          setXApiSubmitFn={(fn) => (widget.xApiSubmitFn = fn)}
          onModified={() => widget.onModified.next()}
          onSave={(submit = false, force = false, triggerWidget = undefined) =>
            widget.onSave.next({ submit, force, triggerWidget })
          }
          state={state}
          index={i}
          answer={widgetCorrection?.answer}
          correction={widgetCorrection?.correction}
          isCorrected={isCorrected}
          showAnswers={showAnswers}
          widgetAnswered={widgetCorrection?.answered}
          lesson={lesson}
          isExtraInfo={isExtraInfo}
          userId={userId}
        />
      </Wrapper>

      {isCorrected && correction?.[state.uid]?.correction?.feedback && (
        <div className="mt-[-1rem] rounded-lg bg-[#f8f8f9] py-2 px-3">
          <p className="text-sm font-semibold text-black">
            {i18n.t('widgets.type.feedback')}
          </p>
          <div
            className={`border-transparen rounded-md border border-solid bg-grey-transparent-01 p-6 text-sm text-grey-08`}
          >
            <div
              className="text-sm font-normal text-[#4d4d50]"
              dangerouslySetInnerHTML={{
                __html: correction?.[state.uid]?.correction?.feedback,
              }}
            ></div>
          </div>
        </div>
      )}
    </>,
    placeholder
  );

  return widget;
}

// export function renderWidgets(parent, correction, props) {
//   const widgets = document.getElementsByClassName('widget-placeholder');
//   console.log(widgets);
//   return [...widgets].reduce((acc, widget, i) => {
//     if (widget.state) return acc; //renderWidget(widget.state, widget, i + 1);
//     let node = widget.querySelectorAll('div[data-state],span[data-state]');
//     if (node.length === 0) return acc;
//     let stateStr = node[0].getAttribute('data-state');
//     try {
//       widget.state = JSON.parse(stateStr); //legacy parsing
//     } catch (e) {
//       widget.state = JSON.parse(decode(stateStr)); //base64 parsing
//     }
//     acc[widget.state.uid] = renderWidget(
//       widget.state,
//       widget,
//       i + 1,
//       correction,
//       props
//     );
//     return acc;
//   }, {});
// }

export function renderWidgets(parent, correction, props, userId, isExtraInfo) {
  correction ||= {};
  const widgets = parent?.getElementsByClassName('widget-placeholder') || [];

  let indexCounter = 0;

  const parts = window.location.pathname.split('/').filter(Boolean);
  const pageType = parts?.[1];

  const userID = userId;

  const matchStudent = window.location.pathname.match(
    /\/follow-up\/[^/]+\/result\/[^/]+\/([^/]+)\//
  );
  const studentId = matchStudent?.[1] || '';

  const xfnv1a = (str) => {
    let h = 2166136261;
    for (let i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return h >>> 0;
  };

  const mulberry32 = (a) => {
    return function () {
      let t = (a += 0x6d2b79f5);
      t = Math.imul(t ^ (t >>> 15), t | 1);
      t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  };

  const seededShuffle = (arr, seedStr) => {
    const rand = mulberry32(xfnv1a(seedStr));
    const a = arr.slice();
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(rand() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  };

  const ensureChildContainer = (groupPlaceholder, childUid, className = '') => {
    let el = groupPlaceholder.querySelector(`#${CSS.escape(childUid)}`);
    if (!el) {
      el = groupPlaceholder.ownerDocument.createElement('div');
      el.id = childUid;
      groupPlaceholder.appendChild(el);
    }
    el.className = className;
    return el;
  };

  const acc = {};

  for (const widget of [...widgets]) {
    if (widget.state) continue;

    const node = widget.querySelectorAll('div[data-state],span[data-state]');
    if (node.length === 0) continue;

    const stateStr = node[0].getAttribute('data-state');
    try {
      widget.state = JSON.parse(stateStr);
    } catch (e) {
      widget.state = JSON.parse(decode(stateStr));
    }

    if (
      widget.state?.type === 'MeerKeuzeGroup' ||
      widget.state?.type === 'OrderVraagGroup' ||
      widget.state?.type === 'SortGroupsGroup' ||
      widget.state?.type === 'ShowOnPictureGroup' ||
      widget.state?.type === 'OpenVraagGroup' ||
      widget.state?.type === 'MatrixVraag2Group' ||
      widget.state?.type === 'NameImage2Group' ||
      widget.state?.type === 'InvulVraagGroup' ||
      widget.state?.type === 'FileUploadGroup' ||
      widget.state?.type === 'LinkGroup'
    ) {
      const groupState = widget.state;

      const items = Array.isArray(groupState?.items) ? groupState.items : [];

      // pick children uids
      let pickedUids;
      if (props?.showAnswers) {
        pickedUids = items.map((x) => x.uid);
      } else {
        const showCount = Math.max(
          1,
          Math.min(Number(groupState?.showCount || 1), items.length || 1)
        );
        const randomPick =
          groupState?.randomPick !== undefined ? groupState.randomPick : true;

        const baseId =
          pageType === 'follow-up' ? studentId || '' : userID || '';
        const seedStr = `${baseId}|${groupState.uid || ''}`;
        const order = randomPick ? seededShuffle(items, seedStr) : items;
        pickedUids = order.slice(0, showCount).map((x) => x.uid);
      }

      widget.innerHTML = '';

      const itemMap = new Map(items.map((x) => [x.uid, x]));

      for (let idx = 0; idx < pickedUids.length; idx++) {
        const uid = pickedUids[idx];

        const item = itemMap.get(uid);
        if (!item) continue;

        const isLast = idx === pickedUids.length - 1;
        const addSpacing = pickedUids.length > 1 && !isLast;

        ensureChildContainer(widget, uid, addSpacing ? 'mb-6' : '');

        const childState = { ...item, type: item?.type };

        const corrByUid = correction?.[uid];

        const childCorrectionObj = {
          [uid]: {
            state: childState,
            answer: corrByUid?.answer,
            correction: corrByUid?.correction,
            answered: corrByUid?.answered,
          },
        };

        acc[uid] = renderWidget(
          childState,
          widget,
          indexCounter + 1,
          childCorrectionObj,
          props,
          isExtraInfo,
          userID
        );

        if (countsTowardQuestionNumber(childState)) indexCounter += 1;
      }

      continue;
    }

    // default: render as normal widget
    acc[widget.state.uid] = renderWidget(
      widget.state,
      widget,
      indexCounter + 1,
      correction,
      props,
      isExtraInfo,
      userID
    );
    if (countsTowardQuestionNumber(widget.state)) indexCounter += 1;
  }

  return acc;
}

export function syncStates(state, answer, correction) {
  let View = getView(state);
  return View.syncStates(state, answer, correction);
}
